import { render } from "./ChatGift.vue?vue&type=template&id=7815cca4"
import script from "./ChatGift.vue?vue&type=script&lang=js"
export * from "./ChatGift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__